import * as _ from 'lodash';

export const selectReportsData = state => _.get(state, 'reports.data', []);
export const selectReportsLoading = state => _.get(state, 'reports.request.loading', false);
export const selectExportLoading = state => _.get(state, 'reports.exportLoading', false);
export const selectReportsError = state => _.get(state, 'reports.request.error', null);
export const selectReportsFilters = state => _.get(state, 'reports.filters', {});
export const selectReportsTotalCount = state => _.get(state, 'reports.totalCount', 0);
export const selectDiscApprovalCount = state => _.get(state, 'reports.discApprovalCount', 0);
export const selectFilteredProjects = state => _.get(state, 'reports.filteredProjects', []);
export const selectAllFilteredClosingIds = state => _.get(state, 'reports.allFilteredClosingIds', []);
export const selectBulkReportStatus = state => _.get(state, 'reports.bulkReportStatus', { success: false, error: null, reportType: null, selectedColumns: null });
